import axios from "axios";
import { getToken } from "./Common.jsx";

// Determine the API base URL based on environment
const getBaseURL = () => {
  // Use the environment variable from .env file
  return process.env.REACT_APP_API_URL;
};

// Get environment info for display
export const getEnvironmentInfo = () => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isProductionAPI = getBaseURL().includes('apidashboard.ashleyhotelgroup.co.id');
  
  return {
    isDevelopment: isLocalhost && !isProductionAPI,
    endpoint: getBaseURL(),
    label: isProductionAPI ? 'Production' : 'Development'
  };
};

const instance = axios.create({
  baseURL: getBaseURL(),
  headers: {
    "Content-Type": "application/json"
  }
});

// Prevent multiple redirects causing reload loops
let isRedirecting401 = false;

// Add a request interceptor to add the auth token on each request
instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle auth errors
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const path = window.location.pathname || '';
      const onLogin = path === '/' || path.startsWith('/login');
      const isAuthEndpoint = error.config && typeof error.config.url === 'string'
        ? ['/login', '/logout'].some(ep => error.config.url.includes(ep))
        : false;
      if (!onLogin && !isAuthEndpoint && !isRedirecting401) {
        isRedirecting401 = true;
        try {
          sessionStorage.clear();
          localStorage.clear();
        } finally {
          window.location.replace('/');
        }
      }
    }
    return Promise.reject(error);
  }
);
export default instance;
